import React from 'react'
import Barcode from "react-barcode";

const OrderBarcode = ({value, text="", width="1.2", height="17"}) => {
  return (
    <div style={{padding:"1px"}} className='text-center'>
      <Barcode displayValue={false} textAlign="center" width={width} height={height} value={value}/>
      <div style={{fontSize: "10px"}} className='text-wrap w-100 text-break font-weight-md text-center'>{text || value}</div>
    </div>
  )
}

export default OrderBarcode